import * as colors from '../assets/js/colors'

// Mesmas cores das badges de status da tela de Movimentação de Estoque - Expedição
export const ExpedicaoStatus = {
  Expedido: {
    label: 'Expedido',
    color: colors.laranja,
  },
  Reaberto: {
    label: 'Reaberto',
    color: colors.pink,
  },
  Finalizado: {
    label: 'Finalizado',
    color: colors.azul_escuro,
  },
  EmConferencia: {
    label: 'Em Conferencia',
    color: colors.vermelho_hover,
  },
  Conferido: {
    label: 'Conferido',
    color: colors.verde_hover,
  },
}
